import type { KnowledgeStatus as Status } from "@peer-start/platform-contracts";
import { AlertTriangle, BookOpen, CheckCircle2, HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const presentation = {
  mastered: { Icon: CheckCircle2, tone: "bg-success text-success-foreground" },
  vulnerable: { Icon: HelpCircle, tone: "bg-warning text-warning-foreground" },
  learning_point: { Icon: BookOpen, tone: "bg-info text-info-foreground" },
  blind_spot: { Icon: AlertTriangle, tone: "bg-destructive text-destructive-foreground" },
};
export function KnowledgeStatus({ status }: { status: Status }) {
  const { t } = useTranslation();
  const { Icon, tone } = presentation[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${tone}`}
    >
      <Icon aria-hidden="true" className="size-3.5" />
      {t(`knowledgeAssessment.status.${status}`)}
    </span>
  );
}
